<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk">Saint Peter and the Goldfinch</h1>
<p class="bkau">Poems by Jack Ridl</p>
<p class="bkpub"><img alt="" height="75" src="images/wsu-logo.jpg" width="75"/></p>
<p class="bkpub1">W<span class="sm">AYNE</span> S<span class="sm">TATE</span> U<span class="sm">NIVERSITY</span> P<span class="sm">RESS</span></p>
<p class="bkpub1">Detroit</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-ridl-0004.vue?05902bdf